module Meevo.Plugins.Employee {
    'use strict';

    /**
    * OnlineBooking Section of Employee 
    */
    export class OnlineBookingSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeOnlineBooking> {
        public onlineBookingAvailability: Model.EmployeeBookingAvailability[];
        public businessHours: Model.BusinessHours[];
        public weekdayEnum = Model.WeekdayNameEnum;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            private modalService: Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.dataService.customMethodData('api/Tenant/BusinessInfo/', 'GET', {}).then(res => {
                this.businessHours = res.data.businessHours;
            });
        }

        sectionModelRetrieved() {
            super.sectionModelRetrieved();
            if (!this.model.employeeBookingAvailability.length) {
                this.model.employeeBookingAvailability = this.businessHours.map(busHour => ({
                    employee_User_TId: this.model.id,
                    isChecked: busHour.isEnabled,
                    weekdayNameEnum: busHour.weekdayName,
                    startTime: busHour.startTime,
                    endTime: busHour.endTime,
                    startDateTime: busHour.startTime,
                    endDateTime: busHour.endTime,
                    weekdayName: busHour.weekdayNameDisplay
                }))
            }

        }

        isTimeRangeInvalid(item: Model.EmployeeBookingAvailability): void {
            var startDateTime = moment(item.startDateTime);
            var endDateTime = moment(item.endDateTime);
            item.isTimeInvalid = endDateTime.isBefore(startDateTime);
        }

        public preSave() {
            var canNotSave = this.model.employeeBookingAvailability.some(a => a.isTimeInvalid);
            if (canNotSave) {
                this.modalService.alert("LABEL_INVALID_EMPLOYEE_AVAILABILITY_TIMES");
                throw ('Invalid Time Range');
            }
            super.preSave();

        }
    }
}